import { render, staticRenderFns } from "./aiWorkspace.vue?vue&type=template&id=ddcdbe30&scoped=true&"
import script from "./aiWorkspace.vue?vue&type=script&lang=js&"
export * from "./aiWorkspace.vue?vue&type=script&lang=js&"
import style0 from "./aiWorkspace.vue?vue&type=style&index=0&id=ddcdbe30&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddcdbe30",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ddcdbe30')) {
      api.createRecord('ddcdbe30', component.options)
    } else {
      api.reload('ddcdbe30', component.options)
    }
    module.hot.accept("./aiWorkspace.vue?vue&type=template&id=ddcdbe30&scoped=true&", function () {
      api.rerender('ddcdbe30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/DestinationBusiness/detail/aiWorkspace.vue"
export default component.exports